export default __webpack_public_path__ + "static/media/mr14.c2f6c2ef.jpg";